export interface FileResponse {
  blob: Blob;
  filename: string;
}

export async function fileResponseHandler(response: Response): Promise<FileResponse> {
  const disposition = response.headers.get("Content-Disposition");
  const filename = disposition?.match(/filename="(.+)"/)?.[1] || "";
  const blob = await response.blob();
  return { blob, filename };
}
